module.exports = __webpack_public_path__ + "assets/img/card-event-placeholder.jpg";